import { render, staticRenderFns } from "./IssueTOC.vue?vue&type=template&id=9f930c92&"
import script from "./IssueTOC.vue?vue&type=script&lang=ts&"
export * from "./IssueTOC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports